<template>
    <section class="hero contact-hero is-hidden-mobile is-hidden-tablet-only is-hidden-desktop-only">
        <div class="hero-body">
            <section class="section">
                <div class="container">
                    <div class="columns">
                        <div class="column is-8 is-offset-4-desktop">
                        <div class="hero-box-right">
                            <p class="title hero-title">
                                Contact Us
                            </p>
                        </div>
                    </div>
                    </div>

                </div>
            </section>
        </div>
    </section>
    <section class="hero map-hero is-hidden-mobile is-hidden-tablet-only is-hidden-desktop-only">
        <div class="hero-body">
            <section class="section">
                <div class="container">
                    <div class="columns">
                        <div class="column is-8 is-offset-4-desktop has-text-right">
                    <div class="hero-box-right">
                        <h3 class="title hero-title">Salt Lake City</h3>
                        <address class="is-size-3">
                            215 S. State St.<br>
                            Suite 1000<br>
                            Salt Lake City, UT 84111
                        </address>
                        </div>
                    </div>
                    </div>

                </div>
            </section>
        </div>
    </section>

    <div class="blue-bg is-hidden-widescreen">
        <img src="https://assets.webbank.com/382.png" alt="WebBank Map" style="margin-bottom: -10px;">
        <img src="https://assets.webbank.com/wbmap2.png" alt="WebBank Map">
        <section class="section">
            <div class="blue-bg container">
        <h2 class="title hero-title-mobile">Contact Us</h2>
                <h3 class="box-title has-text-white">Salt Lake City</h3>
                <address class="is-size-5">
                    215 S. State St.<br>
                    Suite 1000<br>
                    Salt Lake City, UT 84111
                </address>
            </div>
        </section>
    </div>

    <section class="section" v-if="success">
        <div class="container">
            <div class="columns">
                <div class="column is-8 is-offset-2 has-text-centered">
                    <br>
                    <br>
                    <br>
                    <br>
                    <br>
                    <br>
                    <span class="icon has-text-success"><i class="fa-solid fa-badge-check fa-10x"></i></span>
                    <br>
                    <br>
                    <br>
                    <br>
                    <p class="has-text-success is-size-3">Thank you! Your message has been sent!</p>
                    <br>
                    <br>
                    <br>
                    <br>
                </div>
            </div>
        </div>
    </section>

    <section class="section" v-else>
        <div class="container">

                    <div class="has-text-centered">
                    <h3 class="is-size-1 has-text-primary section-title">How Can We Help?</h3>
                    </div>
                    <br>
                    <br>

            <div class="columns">
                <div class="column is-8 is-offset-2">
            <div class="notification is-danger" v-if="this.errors.length">
                Please check your input and try again.
            </div>
                    <div class="columns">
                        <div class="column">
                            <div class="field">
                                <label class="label">First Name</label>
                                <div class="control">
                                    <input class="input"
                                        :class="{'is-danger': this.errors.includes('first_name')}"
                                        type="text"
                                        placeholder="John"
                                        name="first_name"
                                        v-model="form.first_name">
                                </div>
                                <p class="help has-text-danger" v-if="this.errors.includes('first_name')">Please enter your first name.</p>
                            </div>
                        </div>
                        <div class="column">
                            <div class="field">
                                <label class="label">Last Name</label>
                                <div class="control">
                                    <input class="input"
                                        :class="{'is-danger': this.errors.includes('last_name')}"
                                        type="text"
                                        placeholder="Doe"
                                        name="last_name"
                                        v-model="form.last_name">
                                </div>
                                <p class="help has-text-danger" v-if="this.errors.includes('last_name')">Please enter your last name.</p>
                            </div>
                        </div>
                    </div>

                    <div class="columns">
                        <div class="column">
                <div class="field">
                    <label class="label">Email</label>
                    <div class="control has-icons-left has-icons-right">
                        <input class="input"
                            type="email"
                            name="email"
                            :class="{'is-danger': this.errors.includes('email')}"
                            placeholder="me@mycompany.com"
                            v-model="form.email">
                        <span class="icon is-small is-left">
                            <i class="fas fa-envelope"></i>
                        </span>
                    </div>
                    <p class="help has-text-danger" v-if="this.errors.includes('email')">Please enter your email.</p>
                </div>
                        </div>
                        <div class="column">
                            <div class="field">
                                <label class="label">Phone</label>
                                <div class="control">
                                    <input class="input"
                                        :class="{'is-danger': this.errors.includes('phone')}"
                                        v-maska:[options]
                                        type="tel"
                                        name="phone"
                                        placeholder="xxx-xxx-xxxx"
                                        v-model="form.phone">
                                </div>
                                <p class="help has-text-danger" v-if="this.errors.includes('phone')">Please enter your phone number.</p>
                            </div>
                        </div>
                    </div>
                    <div class="columns">
                        <div class="column">
                            <div class="field">
                                <label class="label">Brand Partner</label>
                                <div class="control">
                                    <input class="input"
                                        :class="{'is-danger': this.errors.includes('brand_partner')}"
                                        type="text"
                                        name="brand_partner"
                                        placeholder="My Company"
                                        v-model="form.brand_partner">
                                </div>
                                <p class="help has-text-danger" v-if="this.errors.includes('brand_partner')">Please enter your Company or Brand Partner.</p>
                            </div>
                        </div>
                    </div>

                    <div class="field">
                        <label class="label">Message</label>
                        <div class="control">
                            <textarea class="textarea"
                                name="description"
                                :class="{'is-danger': this.errors.includes('description')}"
                                placeholder="Additional Details"
                                v-model="form.description">
                            </textarea>
                        </div>
                        <p class="help has-text-danger" v-if="this.errors.includes('description')">Please enter a message.</p>
                    </div>

                    <div class="field is-grouped">
                        <div class="control">
                            <button class="button is-primary" @click="submitForm" :class="{'is-loading': sending}">Submit</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

</template>

<script>
import axios from 'axios';
import { vMaska } from "maska"

export default {
    directives: { maska: vMaska },
    data: function () {
        return {
            form: {
                form_name: 'contact_us',
                first_name: null,
                last_name: null,
                email: null,
                phone: null,
                brand_partner: null,
                description: null
            },
            sending: false,
            success: false,
            errors: [],
            options: {
                mask: "###-###-####",
                eager: false
            }
        }
    },

    created() {
        document.title = "Contact Us  - WebBank";
    },

    methods: {
        submitForm: function () {
            this.sending = true;
            this.errors = [];
            console.log('submitting form...');

            for (let x in this.form) {
                console.log('checking form field: ' + x);
                console.log('value: ' + this.form[x]);
                if (!this.form[x]) {
                    console.log('field has an error! - ' + x);
                    this.errors.push(x);
                }
            }
            if (this.errors.length) {
                console.log('failing with validation errors: ', this.errors);
                this.sending = false;
                return false;
            }

            let data = this.form;
            console.log('posting data: ' + JSON.stringify(data));
            axios.post(process.env.VUE_APP_MAIL_ENDPOINT, data)
                .then(result => {
                    console.log('result: ' + JSON.stringify(result));
                    this.success = true;
                }).finally(() => this.sending = false);
        }
    }
}
</script>
